import { useCallback, useEffect, useRef } from 'react';
import { useSignal } from '@preact/signals-react';
import styled from 'styled-components';
import { DropDownWrapper, MenuItem, Loader } from 'components';
import { Pause, PauseAction, Start, StartIcon } from 'assets/icons';
import { campaignReportsAPI } from 'services/campaignReports.service';

const PAUSED_STATUS = 3;
const ACTIVE_STATUS = 0;

export const CampaignStatusAction = ({ campaignId, status = ACTIVE_STATUS }) => {
  const triggerRef = useRef(null);
  const isOpen$ = useSignal(false);
  const [updateCampaignStatus, result] = campaignReportsAPI.useUpdateCampaignStatusMutation();

  const isPaused = +status === PAUSED_STATUS;
  const Icon = isPaused ? Pause : Start;
  const actionLabel = isPaused ? 'Play Now' : 'Pause Now';
  const ActionIcon = isPaused ? StartIcon : PauseAction;
  const nextStatus = isPaused ? ACTIVE_STATUS : PAUSED_STATUS;

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (triggerRef.current?.contains(event.target)) return;

      isOpen$.value = false;
    };

    document.addEventListener('click', closeOnOutsideClick, true);
    return () => document.removeEventListener('click', closeOnOutsideClick, true);
  }, []);

  const statusAction = useCallback(() => {
    isOpen$.value = false;
    updateCampaignStatus({
      campaignId,
      status: nextStatus,
    });
  }, [campaignId, nextStatus]);

  return (
    <Wrap ref={triggerRef}>
      {result.isLoading && <Loader.Global delay={1000} />}
      <IconButton
        type='button'
        onClick={() => (isOpen$.value = !isOpen$.value)}
        isOpen={isOpen$.value}
      >
        <Icon />
      </IconButton>
      <DropDownWrapper
        isOpen$={isOpen$}
        width={180}
        targetRef={triggerRef}
        style={{ top: '32px', left: '0' }}
        outSideClickAction={() => (isOpen$.value = false)}
      >
        <MenuItem
          height={40}
          icon={ActionIcon}
          value={actionLabel}
          id={isPaused ? 'play_now' : 'pause_now'}
          onClick={statusAction}
        >
          {actionLabel}
        </MenuItem>
      </DropDownWrapper>
    </Wrap>
  );
};

const Wrap = styled.div`
  position: relative;
  flex-shrink: 0;
`;

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`;
